class AddressBookMapper {
  static createAddressBookFromResponse(response) {
    return {
      id: response.id,
      alias: response.alias || `${response.name} ${response.surname}`,
      alpha2Code: response.country,
      city: response.city,
      address: response.address,
      phone: response.phone,
      company: response.company,
      firstName: response.name,
      lastName: response.surname,
      email: response.email,
      zipCode: response.postal_code,
      postalCodeId: response.postal_code_id,
      postalZone: {
        id: response.postal_zone.id,
        translations: Object.fromEntries(Object.entries(response.postal_zone.translations).map(_ref => {
          let [backendLocale, country] = _ref;
          return [backendLocale.replace('_', '-'), country];
        }))
      }
    };
  }
  static createApiPayload(address) {
    return {
      address: address.address,
      alias: address.alias,
      city: address.city,
      company: address.company,
      country: address.alpha2Code,
      email: address.email.trim(),
      id: address.id,
      name: address.firstName,
      phone: address.phone,
      postal_code: address.zipCode,
      surname: address.lastName
    };
  }
}

export { AddressBookMapper };
//# sourceMappingURL=AddressBookMapper.js.map
